import { curry, compose, head, find, cond, always, flip, T, identity } from 'ramda';
import parseCode from './parseCode.js';
import subInBetweenIndexes from './subInBetweenIndexes.js';
import { File, Rank } from '../presets/terms.js';
import '../presets/rules.js';

function getAnimationAxis(e,r,a){var o=compose(parseCode,head)(a),n=o.side,i=o.fileName,d=o.rankName,s=compose(parseCode,find(parseCode.eq(["side",n])))(r),t=s.fileName,m=s.rankName,p=cond([[always(e),flip],[T,identity]])(subInBetweenIndexes);return {targetCode:head(a),from:{x:p(t,i,File),y:p(Number(m),Number(d),Rank)}}}var getAnimationAxis$1 = curry(getAnimationAxis);

export { getAnimationAxis$1 as default };
//# sourceMappingURL=getAnimationAxis.js.map
